import { useUser } from '@lopo-tech/lopo-api'
import * as React from 'react'
import LoadingSpinner from 'src/components/loading_spinner/loading_spinner'
import { useSelectIsUserLoggedIn } from '../reducers/user/user_hooks'

const DeferUtilMeFetched: React.FC = ({ children }) => {
  const isLoggedIn = useSelectIsUserLoggedIn()
  const { data, loading } = useUser({ skip: !isLoggedIn })
  return (
    <>
      {loading && !data ? <LoadingSpinner shown={true}/> : children}
    </>
  )
}

export default DeferUtilMeFetched
